import firebase from 'firebase/app';
import "firebase/firestore";
import "firebase/storage";
const config = {
  apiKey: "AIzaSyCCWJxmUasdV_Vcx0PKY3rZYQz4if4dvc0",
  authDomain: "mymeatloaf-app.firebaseapp.com",
  databaseURL: "https://mymeatloaf-app.firebaseio.com",
  projectId: "mymeatloaf-app",
  storageBucket: "mymeatloaf-app.appspot.com",
  messagingSenderId: "1070685022671",
  appId: "1:1070685022671:web:a135b83eda6c8915aa0aba",
  measurementId: "G-7VZ8T098E2"
};

  firebase.initializeApp(config);

  export default firebase;